import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a6578b96d1652258cc323f715cd7e6d23b from "./generated-91a422aa-0046-472e-bc09-f18f50172ae4.json";

import a205a0361adee0686ad0f59473b2602c8b from "./generated-17708833-0ca9-4d11-8b9e-1d7826722c67.json";

import ac46abb1a857b1671aaba6b1f78b43a63b from "./generated-5534a489-6da0-4c33-a120-018166bd3553.json";

import a441f3899f8e759614f9fd60924587462b from "./generated-a8733648-0eed-4f29-b02b-0ea8dd151902.json";

import a8c66d2b09ce13ba4b2638b8290b5a802b from "./generated-437e9192-a289-4b29-afa4-c72f2cae981b.json";

import aebe9f0a1dda49727076f74881d6e7314b from "./generated-b47902ae-b951-44b7-bf32-9c0853ffd962.json";

import a7d31327f5ea3b44ba022ce2233593655b from "./generated-644b7289-2f0d-448c-950a-bac108a78f4b.json";

import a23782b85288f6457542b764f79d9c385b from "./generated-090de130-ab60-4337-8603-214013c3226e.json";

import a4c78ec011bb6bf01db6d058ea11f4e2eb from "./generated-27c0b2cf-aab9-4abd-af1e-04dfa098eb3c.json";

import a0c7e23aaa54648920a402f1fb0a313e3b from "./generated-2e2d68ee-69e5-47c3-a648-b19f0a750763.json";

import a5d6e2377652f9a9af2b9aa3407010a99b from "./generated-b2fb1949-13d7-49ca-8189-50f0623f657f.json";

import a2a42e05af02d403151352e1a9420e7a2b from "./generated-06c6aa50-7229-4daa-9a32-5a085b586c1e.json";

import a59020da4ba1c2713e06ef894cbe618c8b from "./generated-e4edf188-fab4-49b6-8b03-f581f92a9bdb.json";

import a7036ee8aff3a6496db2439ea17ced7ebb from "./generated-dd39ef97-afb1-4964-b435-76360add65c9.json";

import a62733cc109a2b52a0b66577b75d78fd0b from "./generated-a44835a3-11fd-4c0f-a3aa-4de4d3214922.json";

import ab4b379a813abe1f54c6c9a1a13ace73cb from "./generated-927a762c-64db-4453-9e6b-e51474fe8028.json";

import a542ee7629c110afe13f4d56dd6dc7d37b from "./generated-bc51699b-76c3-46f8-9cf1-4635a503421b.json";

import acbb8bfca74028ed9384309a1be5c3aaab from "./generated-18a9fed7-aa15-4571-ae4e-34c6d72d5528.json";

import ac2f2ca57c12bd5e72e9cef8ad2abaf37b from "./generated-c0301ad2-734a-4157-a325-8c1db82961d9.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a6578b96d1652258cc323f715cd7e6d23b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a205a0361adee0686ad0f59473b2602c8b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ac46abb1a857b1671aaba6b1f78b43a63b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a441f3899f8e759614f9fd60924587462b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a8c66d2b09ce13ba4b2638b8290b5a802b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(aebe9f0a1dda49727076f74881d6e7314b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a7d31327f5ea3b44ba022ce2233593655b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a23782b85288f6457542b764f79d9c385b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a4c78ec011bb6bf01db6d058ea11f4e2eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a0c7e23aaa54648920a402f1fb0a313e3b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a5d6e2377652f9a9af2b9aa3407010a99b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a2a42e05af02d403151352e1a9420e7a2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a59020da4ba1c2713e06ef894cbe618c8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a7036ee8aff3a6496db2439ea17ced7ebb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a62733cc109a2b52a0b66577b75d78fd0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ab4b379a813abe1f54c6c9a1a13ace73cb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a542ee7629c110afe13f4d56dd6dc7d37b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(acbb8bfca74028ed9384309a1be5c3aaab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ac2f2ca57c12bd5e72e9cef8ad2abaf37b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a542ee7629c110afe13f4d56dd6dc7d37b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */